export function axIsTypeBoolean(x) {
    return typeof x === 'boolean';
}
